module.exports = __webpack_public_path__ + "img/liotron_150ah.4e70bc02.png";